export default "__VITE_ASSET__DjiOjdYS__"